<template>
    <ui-crud title="PPE Register" subtitle="A list of PPE Registers for this package" ref="crud"
             :fetch="fetch" :pipe-with="pipeItems" :group-by="groupByStatus">

        <!-- Filters. -->
        <template #filters>
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
        </template>

        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :title="`${item.formattedDate}`"
                :subtitle="`${item.givenByName}`"
                :metadata="`${item.numberOfPeople} people`"
                :active="active"
                @click="select()"
            ></ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ addItem }">
            <ppe-register-form :package-reference="packageReference" :package-name="packageName"
                               :add-item="addItem"
                               :contacts="contacts"></ppe-register-form>
        </template>

        <!-- Edit form. -->
        <template #edit="{ selectedItem, setEditMode }">
            <ppe-register-form :package-reference="packageReference" :package-name="packageName"
                               :item="selectedItem"
                               :edit="setEditMode"
                               :contacts="contacts"></ppe-register-form>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem, addItem }">
            <ppe-register-show :package-reference="packageReference" :package-name="packageName"
                               :item="selectedItem"
                               :edit="setEditMode" :add-item="addItem" @print="print" :contacts="contacts"
                               :remove-item="removeItem"></ppe-register-show>
        </template>
    </ui-crud>
</template>

<script>
import {Contact, PPERegister} from "@models";
import PpeRegisterForm from "./PpeRegisterForm.vue";
import PpeRegisterShow from "./PpeRegisterShow.vue";
import moment from "moment/moment";
import UiCrud from "../../ui/UiCrud.vue";
import UiCrudCard from "../../ui/UiCrudCard.vue";
import UiInput from "../../ui/UiInput.vue";

export default {
    components: {UiInput, UiCrudCard, UiCrud, PpeRegisterShow, PpeRegisterForm},
    props: {
        packageReference: null,
        packageName: null,
        showWhenLoaded: null
    },
    data() {
        return {
            search: '',
            contacts: {data: [], loaded: false},
            package: {},
            iframe: null,
            items: [],
        }
    },
    methods: {
        async fetch(itemId) {
            this.loaded = false
            this.items = await PPERegister.all(this.packageReference)
            if (itemId) {
                this.$refs.crud.selectItem(this.items.find((i) => i.id === itemId))
            } else if (this.items.length) {
                this.$refs.crud.selectItem(this.items[0])
            }
            this.loaded = true
            return this.items;
        },
        pipeItems(items) {
            const query = this.search.toLowerCase().split(/[^A-Za-z0-9.\/-]+/).filter((i) => i !== '')
            if (query.length) {
                return this.items.filter((induction) => {
                    return query.every((token) => {
                        return induction.tokens.includes(token);
                    })
                });
            }
            return this.items;
        },
        groupByStatus(item) {
            return item.status;
        },
        print(url) {
            if (!this.iframe) {
                this.iframe = document.createElement('iframe');
                this.iframe.setAttribute('style', 'display:none');
                this.iframe.src = "";
                this.iframe.name = 'pdf';
                this.iframe.onload = () => {
                    this.$nextTick(() => {
                            setTimeout(() => {
                                const pdfFrame = window.frames["pdf"];
                                pdfFrame.focus();
                                pdfFrame.print();
                            }, 100)
                        }
                    )
                }
            }
            this.iframe.src = url + '?time=' + moment().format('x')
        },
    },
    async mounted() {
        this.contacts.data = await Contact.all()
        this.contacts.loaded = true;
        if (this.showWhenLoaded) {
            this.$refs.crud.fetch(this.showWhenLoaded)
        }
    }
}
</script>
